import { api } from '@/lib/axios'

export async function GetPatrocinadoresFn() {
  const response = await api.get('patrocinadores')

  return response.data
}
